import React from 'react';
import config from '../../../../helpers/config';

const ContactFooter = () => (
  <div className="questions">
    Questions? Call us at {' '}
    <a href={`tel:${config.supportPhoneNumber}`}>{config.supportPhoneNumber}</a>.
  </div>
);

export default ContactFooter;
